import React from 'react'
import { Form } from '@s4l/ds'
import { IconTrash } from '@s4l/icons/IconTrash'
import { useS4LContext } from '@s4l/react-context'
import {
  PAY_LATER,
  PAY_NOW_FULL,
  PAY_PARTIAL,
} from '@s4l/stayforlong/property/domain/PaymentOption'
import { CANCELLABLE } from '@s4l/stayforlong/property/domain/CancellationPolicy'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'

const FilterPaymentAndCancellation = () => {
  const { i18n } = useS4LContext()

  const availableCancellationPolicies = [
    {
      id: 1,
      name: i18n.formatMessage({ id: 'board-filter.free-cancellation' }),
      slug: CANCELLABLE,
    },
  ]

  const availablePaymentOptions = [
    { id: 1, name: i18n.formatMessage({ id: 'board-filter.pay-later' }), slug: PAY_LATER },
    { id: 2, name: i18n.formatMessage({ id: 'filter.pay-now-diposit' }), slug: PAY_PARTIAL },
    { id: 3, name: i18n.formatMessage({ id: 'filter.pay-now-full' }), slug: PAY_NOW_FULL },
  ]

  return (
    <Form.Fieldset>
      <Form.Legend>{i18n.formatMessage({ id: 'filter-category.payment-title' })}</Form.Legend>
      <Form.ClearButton icon={<IconTrash />}>
        {i18n.formatMessage({ id: 'serp.filter-clear' })}
      </Form.ClearButton>
      {availableCancellationPolicies.map(policy => (
        <Form.Label key={`cancellation-policy-${policy.id}`}>
          {policy.name}
          <Form.Checkbox name="cancellationPolicies" multiple trueValue={policy.slug} />
        </Form.Label>
      ))}
      {availablePaymentOptions.map(option => (
        <Form.Label key={`payment-option-${option.id}`}>
          {option.name}
          <Form.Checkbox name="paymentOptions" multiple trueValue={option.slug} />
        </Form.Label>
      ))}
    </Form.Fieldset>
  )
}

FilterPaymentAndCancellation.displayName = 'SearchFilters.FilterPaymentAndCancellation'
export default withErrorBoundary(FilterPaymentAndCancellation)
